import { write } from "./write"
import { read } from "./read"

export const template = {
  write,
  read,
}
